<template>
    <section class="hero is-fullheight">

        <div id="context_bar"></div>

        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-3">{{ $t('modules.auth.unautorized.title') }}</h1>
            </template>
        </titlePage>

        <div id="index_positions_content" class="hero flex">
            <div class="hero-body flex_content">

                <div class="container micro-container has-text-centered ">

                    <div class="pack_active_bloc">
                        <div v-if="!uAccess.active_licence_and_contract">
                            <div v-if="uAccess.contract.subscription_plan == 'custom'">
                                <p>{{ $t('modules.auth.unautorized.custom_pack_expired') }}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </section>
</template>

<script>
import TitlePage from "@/components/layouts/titlePage"

export default {
    name: 'Unautorized',
    components: {
        TitlePage
    },
    mounted(){
        console.log(this.uAccess)

    },
    data(){
        return {
            monthPrice: false,
            uAccess: JSON.parse(localStorage.getItem('account'))
        }
    },
    computed: {
        startContractDate(){
            return this.$date(this.uAccess.contract.start_date, "YYYY-MM-DD HH:mm:ss").locale(this.$i18n.locale).format('DD/MM/YYYY')
        },
        endContractDate(){
            return this.$date(this.uAccess.contract.end_date, "YYYY-MM-DD HH:mm:ss").locale(this.$i18n.locale).format('DD/MM/YYYY')
        }
    },
    methods: {
    }
}

</script>

<style lang="scss">
.pack_info_bloc{
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
}
.pack_active_bloc{
    p{
        margin-bottom: 12px;
    }
    padding-bottom: 15px;
    margin-bottom: 50px;
    border-bottom: 1px solid #ddd;
}

</style>
